import { jsx as _jsx } from "react/jsx-runtime";
import { InputWrapper } from "./InputWrapper";
import { PasswordInputElement } from "./PasswordInput";
export function NewPasswordInput(props) {
    // the InputWrapper renders it's children plus a label, helpBlock and any error message from the field validation
    return (_jsx(InputWrapper, Object.assign({}, props, { children: _jsx(PasswordInputElement, Object.assign({}, props)) })));
}
